import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { getUserInfoDataForEAPM } from '../../tools/utils/utils';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'GET_CREDENTIALS';

export const useUserStatus = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });

  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let transaction;
    let status;
    let statusText;
    let dtrumActionId;
    if (eapm) {
      transaction = eapm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: false,
      });
    }

    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      const orgIdHeader = args.orgId;
      let addHeaders = {};
      if (orgIdHeader) {
        addHeaders = {
          orgId: orgIdHeader,
        };
      }
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('AWS_PROXY_URL')}${config('CREDENTIALS_URL')}?q=${ACTION_TYPE}`);
      fetch(`${config('AWS_PROXY_URL')}${config('CREDENTIALS_URL')}`, {
        credentials: 'include',
        headers: { ...addHeaders },
      })
        .then((res) => {
          status = res.status;
          statusText = res.statusText;

          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('CREDENTIALS_URL'),
              userInfo: args?.userInfo,
              method: 'GET',
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
            },
          });
          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('FEEDBACK_URL'),
            status: 0,
            message: 'Success',
            url: window.location.href,
            result: 'success',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });

          if (res.status !== 200) {
            throw new Error('Get credentials call failed');
          }
          return res.json();
        })
        .then((res) => {
          if (!res.credentials) {
            throw new Error('Incomplete Get credentials data returned');
          }
          dispatch({
            type: `${ACTION_TYPE}_COMPLETED`,
            payload: res,
          });
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('CREDENTIALS_URL'),
              userInfo: args?.userInfo,
              method: 'GET',
              operationName: ACTION_TYPE,
            },
          });

          event('API_TRANSACTION_ERROR', {
            actionId: dtrumActionId,
            endpoint: config('CREDENTIALS_URL'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
          });
        })
        .finally(() => {
          if (transaction) {
            const outcome = status && status === 200 ? 'success' : 'error';

            transaction.addLabels({
              result: outcome,
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('CREDENTIALS_URL'),
              method: 'GET',
              code: status,
              message: statusText,
              ...getUserInfoDataForEAPM(args?.userInfo),
              operationName: ACTION_TYPE,
            });

            transaction.end({ outcome });
          }
        });
    };
  });

  return [result, action];
};
